"use strict";const s=require("./Tabs.js");module.exports=s;
//# sourceMappingURL=index.js.map
